import { fetchJSON as fetchAPI } from './client';

const API_BASE = import.meta.env.VITE_BRAND_API ?? '/api/v1/brands';

export type Brand = {
  id: string;
  tenant_id: string;
  organization_id: string;
  slug: string;
  name: string;
  status: string;
  logo_url?: string;
};

export type BrandDNA = {
  id: string;
  brand_id: string;
  version: number;
  personality: { tone?: string[]; target_audience?: string[] };
  writing_style: { forbidden_claims?: string[] };
  brand_promise?: string;
  confidence: number;
};

async function fetchJSON<T>(path: string, init?: RequestInit): Promise<T> {
  return fetchAPI<T>(API_BASE, path, init);
}

export const brandApi = {
  list: (organizationId?: string) =>
    fetchJSON<Brand[]>(organizationId ? `?organization_id=${organizationId}` : ''),
  create: (body: { organization_id: string; name: string; slug?: string }) =>
    fetchJSON<Brand>('', { method: 'POST', body: JSON.stringify(body) }),
  get: (id: string) => fetchJSON<Brand>(`/${id}`),
  buildDNA: (id: string, body?: { store_title?: string; brand_story?: string }) =>
    fetchJSON<BrandDNA>(`/${id}/dna`, { method: 'POST', body: JSON.stringify(body ?? {}) }),
  getDNA: (id: string) => fetchJSON<BrandDNA>(`/${id}/dna`),
};
